import styled from "styled-components";
import { toVWDesktop } from "../../helpers/styles";
import { toVWMobile } from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";

export const Title = styled.h2`
  font-size: ${toVWMobile(32)}vw;
  font-weight: 900;
  line-height: 96%;
  letter-spacing: ${toVWMobile(0.96)}vw;
  margin:0;
  text-align: center;
  text-transform: uppercase;

@media (min-width: ${BREAKPOINTS.DESKTOP}px) {
  font-size: ${toVWDesktop(56)}vw;
  letter-spacing: ${toVWDesktop(2.24)}vw;
}
`;

export const Subtitle = styled.h3`
  font-size: ${toVWMobile(18)}vw;
  font-weight: 600;
  line-height: 140%;
  margin:0;
  margin-top: ${toVWMobile(8)}vw;
  text-align: center;
  margin-inline: auto;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${toVWDesktop(18)}vw;
    margin-top: ${toVWDesktop(8)}vw;
    max-width: ${toVWDesktop(742)}vw;
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${toVWMobile(20)}vw;
  margin-top: ${toVWMobile(20)}vw;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    gap: ${toVWDesktop(40)}vw;
    margin-top: ${toVWDesktop(40)}vw;
    flex-wrap: wrap;
    flex-direction: row;
  }
`;

export const LowerInteractiveArea = styled.a`
  position: relative;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  width: 100%;
  border-bottom-width: 2px;
  border-bottom-style: solid;
  padding: 0;
  padding-top: ${toVWMobile(18)}vw;
  padding-bottom: ${toVWMobile(8)}vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${toVWMobile(16)}vw;
  line-height: 150%;
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-weight: 800;
  margin-top: auto;
  transition: 0.2s ease-in-out;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    height: 2px;
    width: 100%;
    background-color: #FFFFFF;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.2s ease-in-out;
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-top: ${toVWDesktop(18)}vw;
    padding-bottom: ${toVWDesktop(8)}vw;
    font-size: ${toVWDesktop(16)}vw;
  }
`;

export const QuoteCardImageContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;
  overflow: hidden;
  outline: none;
  border: none;
`;

export const QuoteCardImage = styled.img`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 1/1;
  transition: 0.2s ease-in-out;
`;

export const QuoteCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-decoration: none;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    flex: 1 1 calc(33.333% - ${toVWDesktop(27)}vw);
    min-width: calc(33.333% - ${toVWDesktop(27)}vw);
    max-width: calc(33.333% - ${toVWDesktop(27)}vw);
  }
`;

export const QuoteText = styled.p`
  font-size: ${toVWMobile(18)}vw;
  text-align: left;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  margin-top: ${toVWMobile(12)}vw;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${toVWDesktop(18)}vw;
    margin-top: ${toVWDesktop(12)}vw;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${toVWMobile(24)}vw;
  height: ${toVWMobile(24)}vw;
  border-radius: 50%;
  padding: ${toVWMobile(6)}vw;
  transition: 0.2s ease-in-out;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    width: ${toVWDesktop(24)}vw;
    height: ${toVWDesktop(24)}vw;
    padding: ${toVWDesktop(6)}vw;
  }
`;

export const Icon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: 0.2s ease-in-out;
`;

export const Container = styled.div<{ backgroundColor?: string, color?: string }>`
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};

  ${LowerInteractiveArea} {
    color: ${(props) => props.color};
    border-color: ${(props) => props.color};
    &:hover, &:focus-visible  {
      ${IconContainer} {
        background-color: #FFFFFF;
        ${Icon} {
          scale: 0.8;
        }
      }

      &::after {
        transform: scaleX(1);
      }
    }
  }

  ${QuoteCard}{
    color: ${(props) => props.color};
  }

  direction: ltr;
  padding: ${toVWMobile(44)}vw ${toVWMobile(16)}vw;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${toVWDesktop(80)}vw ${toVWDesktop(100)}vw;
  }
`;

export const PlayIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: none;
  outline: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.1s ease-in-out;
  width: ${toVWMobile(48)}vw;
  height: ${toVWMobile(48)}vw;
  padding: ${toVWMobile(12)}vw;
  background-color: #75C154;

  img {
    transform: translateX(10%);
    transition: 0.1s ease-in-out;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    width: ${toVWDesktop(64)}vw;
    height: ${toVWDesktop(64)}vw;
    padding: ${toVWDesktop(20)}vw;
  }
`;

export const UpperInteractiveArea = styled.button`
  color: inherit;
  font-family: inherit;
  border: none;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: pointer;

  &:hover, &:focus-visible {
    ${PlayIcon} {
      width: ${toVWDesktop(72)}vw;
      height: ${toVWDesktop(72)}vw;
      padding: ${toVWDesktop(24)}vw;
      background-color: #CBEBBD;
    }

    ${QuoteCardImageContainer} > img {
      transform: scale(1.1);
    }
  }
`
